var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCognyModelLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 816 446",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498 333.5H318C306.672 333.5 298.227 333.499 291.732 332.626C285.252 331.755 280.789 330.023 277.383 326.617C273.977 323.211 272.245 318.748 271.374 312.268C270.501 305.773 270.5 297.328 270.5 286V126C270.5 114.672 270.501 106.227 271.374 99.7321C272.245 93.252 273.977 88.7893 277.383 85.383C280.789 81.9767 285.252 80.2454 291.732 79.3742C298.227 78.5011 306.672 78.5 318 78.5H498C509.328 78.5 517.773 78.5011 524.268 79.3742C530.748 80.2454 535.211 81.9767 538.617 85.383C542.023 88.7893 543.755 93.252 544.626 99.7321C545.499 106.227 545.5 114.672 545.5 126V286C545.5 297.328 545.499 305.773 544.626 312.268C543.755 318.748 542.023 323.211 538.617 326.617C535.211 330.023 530.748 331.755 524.268 332.626C517.773 333.499 509.328 333.5 498 333.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_991_9328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318 334H498C520.627 334 531.941 334 538.971 326.971C546 319.941 546 308.627 546 286V126C546 103.373 546 92.0589 538.971 85.0294C531.941 78 520.627 78 498 78H318C295.373 78 284.059 78 277.029 85.0294C270 92.0589 270 103.373 270 126V286C270 308.627 270 319.941 277.029 326.971C284.059 334 295.373 334 318 334Z",
    fill: "black",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      opacity: 0.5,
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#E3D6FF"
    },
    d: "M268,206L268,206c-22.5,0-43.8-10.5-57.4-28.5l-9.2-12.1C182.5,140.6,153,126,121.8,126H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M268,206L268,206c-16.4,0-31.2-9.7-37.8-24.8l-32.7-75.1C181.6,69.6,145.6,46,105.8,46H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M548,206H365.4H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#CCF2F2"
    },
    d: "M268,206L268,206c-22.5,0-43.8,10.5-57.4,28.5l-9.2,12.1C182.5,271.4,153,286,121.8,286H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M268,206L268,206c-16.4,0-31.2,9.7-37.8,24.8l-32.7,75.1c-15.9,36.5-51.9,60.1-91.7,60.1H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M748,289h-60.2c-31.8,0-61.8-15.2-80.6-40.9L593,228.8c-10.5-14.3-27.2-22.8-45-22.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M748,119h-58.8c-32.6,0-63.2,15.9-81.9,42.7l-14.8,21.2C582.3,197.4,565.7,206,548,206l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "line",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M408,239V129"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeDasharray: "4px 17px",
      strokeDashoffset: 0,
      strokeWidth: 4,
      strokeLinecap: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "signal signal1",
    style: {
      stroke: "#E3D6FF"
    },
    d: "M268,206L268,206c-22.5,0-43.8-10.5-57.4-28.5l-9.2-12.1C182.5,140.6,153,126,121.8,126H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal2",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M268,206L268,206c-16.4,0-31.2-9.7-37.8-24.8l-32.7-75.1C181.6,69.6,145.6,46,105.8,46H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal3",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M548,206H365.4H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal4",
    style: {
      stroke: "#CCF2F2"
    },
    d: "M268,206L268,206c-22.5,0-43.8,10.5-57.4,28.5l-9.2,12.1C182.5,271.4,153,286,121.8,286H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal5",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M268,206L268,206c-16.4,0-31.2,9.7-37.8,24.8l-32.7,75.1c-15.9,36.5-51.9,60.1-91.7,60.1H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal6",
    style: {
      stroke: "#D3E6F8"
    },
    d: "M748,289h-60.2c-31.8,0-61.8-15.2-80.6-40.9L593,228.8c-10.5-14.3-27.2-22.8-45-22.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal7",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M748,119h-58.8c-32.6,0-63.2,15.9-81.9,42.7l-14.8,21.2C582.3,197.4,565.7,206,548,206l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "signal signal8",
    style: {
      stroke: "#F5D2ED"
    },
    d: "M408,239V129"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_991_9328",
    x: 270,
    y: 78,
    width: 276,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_991_9328"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognyModelLines);
export default __webpack_public_path__ + "static/media/cognyModelLines.0b2eeb1bec73eafd68a190a17d666dd7.svg";
export { ForwardRef as ReactComponent };